import { AnyAction } from "redux";
import { normalActionTypes } from "../actions/climateShiftAction";
import { IGetLocationsResModel, IOptionsModel, TemperatureStatResponse } from "@/util/http/ClimateShift/responseType";
import { ClimateShiftAddOrShowFavouritesEnum } from "@/util/cosntants";


interface IClimateShiftModel {
    selectedLocationData: IGetLocationsResModel;
    chartResult: TemperatureStatResponse[];
    searchLoading: boolean;
    successMessage?: string;
    errorMessage?: string;
    warningMessage?: string;
    addOrShowFavouritesModal?: ClimateShiftAddOrShowFavouritesEnum;
    authorCode?: string;
    selectedFavouriteItem?: IOptionsModel;
    downloadAllLoading?: boolean;
    country?: string;
    selectedLocationDataForAverage?: IGetLocationsResModel;
    selectedFavouriteId: number | null;
}

const initialState: IClimateShiftModel = {
    selectedLocationData: null,
    chartResult: [],
    searchLoading: false,
    successMessage: "",
    errorMessage: "",
    warningMessage: "",
    addOrShowFavouritesModal: null,
    authorCode: "",
    downloadAllLoading: false,
    country: undefined,
    selectedLocationDataForAverage: null,
    selectedFavouriteId: null,
};

const climateShiftReducer = (
    state = initialState,
    action: AnyAction
): IClimateShiftModel => {
    switch (action.type) {
        case normalActionTypes.NORMAL_UPDATE_LOCATION_SELECTEDLOCATIONDATA:
            return {
                ...state,
                selectedLocationData: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_LOCATION_FETCHEDCHARTDATA:
            return {
                ...state,
                chartResult: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_LOCATION_SEARCHLOADING:
            return {
                ...state,
                searchLoading: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_SUCCESSMESSAGE:
            return {
                ...state,
                successMessage: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_ERRORMESSAGE:
            return {
                ...state,
                errorMessage: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_WARNINGMESSAGE:
            return {
                ...state,
                warningMessage: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_ADDORSHOWFAVOURITESMODAL:
            return {
                ...state,
                addOrShowFavouritesModal: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_AUTHORCODE:
            return {
                ...state,
                authorCode: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_SELECTED_FAVOURITEITEM:
            return {
                ...state,
                selectedFavouriteItem: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_DOWNLOADALLLOADING:
            return {
                ...state,
                downloadAllLoading: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_COUNTRY:
            return {
                ...state,
                country: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_LOCATION_SELECTEDLOCATIONDATAFORAVERAGE:
            return {
                ...state,
                selectedLocationDataForAverage: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_SELECTED_FAVOURITEID:
            return {
                ...state,
                selectedFavouriteId: action.payload
            };
        default:
            return state;
    }
};

export type {
    IClimateShiftModel
};

export default climateShiftReducer;